export const OrderStatusOptions = [
  'Pending',
  'Assigned',
  'Scheduled',
  'Confirmed',
  'Completed',
  'Problem',
  'Cancelled',
  'On Hold'
];
export const BloodWorkCompletedOptions = ['Yes'];
export const PatientStatusOptionsForPMWorkbook = [
  'Consented',
  'Screened',
  'Randomized',
  'Completed',
  'Screen Failed',
  'Withdrawn',
  'Early Termination'
];
